import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { averageLabel, percentLabel, scaleLabel, scoreLabel, statusLabel } from '../Config/Csat/csatScreen';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

export const CsatSummaryCards = ({ summary }) => (
  <div className="csat-metrics">
    <div className="csat-metric">
      <p className="csat-metric-value" data-testid="csat-started">{summary.started}</p>
      <p className="csat-metric-label">Pesquisas iniciadas</p>
    </div>
    <div className="csat-metric">
      <p className="csat-metric-value" data-testid="csat-response-rate">{percentLabel(summary.responseRate)}</p>
      <p className="csat-metric-label">Taxa de resposta</p>
    </div>
    <div className="csat-metric">
      <p className="csat-metric-value" data-testid="csat-percent">{percentLabel(summary.csatPercent)}</p>
      <p className="csat-metric-label">CSAT %</p>
    </div>
    <div className="csat-metric">
      <p className="csat-metric-label">Média</p>
      {['5', '10'].map((scale) => (
        <p key={scale} className="csat-metric-line" data-testid={`csat-average-${scale}`}>
          {`Escala ${scaleLabel(scale)}: ${averageLabel(summary.byScale[scale].average)}`}
        </p>
      ))}
    </div>
  </div>
);

export const CsatDistributionChart = ({ scale, data }) => {
  const labels = Object.keys(data.distribution);
  return (
    <div data-testid={`csat-distribution-${scale}`}>
      <p className="csat-chart-title">{`Distribuição das notas (escala ${scaleLabel(scale)})`}</p>
      <Bar
        data={{ labels, datasets: [{ label: 'Respostas', data: labels.map((score) => data.distribution[score]), backgroundColor: '#4A7BA7' }] }}
        options={{ responsive: true, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, ticks: { precision: 0 } } } }}
      />
    </div>
  );
};

const formatDate = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
};

export const CsatRankingTable = ({ title, keyLabel, items }) => (
  <div className="section-card">
    <div className="card-header-custom">
      <h2 className="card-title">{title}</h2>
    </div>
    <div className="card-content-custom">
      {items.length === 0 ? <p className="csat-empty">Sem respostas no período.</p> : (
        <div className="report-table-wrapper">
          <table className="report-table">
            <thead>
              <tr className="report-table-header">
                <th>{keyLabel}</th>
                <th>Respondidas</th>
                <th>CSAT %</th>
                <th>Média (1 a 5)</th>
                <th>Média (1 a 10)</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.key}>
                  <td>{item.insufficientSample ? `${item.key} (amostra pequena)` : item.key}</td>
                  <td>{item.answered}</td>
                  <td>{percentLabel(item.csatPercent)}</td>
                  <td>{averageLabel(item.averageByScale['5'])}</td>
                  <td>{averageLabel(item.averageByScale['10'])}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);

export const CsatResponsesTable = ({ items, canDownloadRecording = false, onDownloadRecording = () => {} }) => (
  <div className="report-table-wrapper">
    <table className="report-table">
      <thead>
        <tr className="report-table-header">
          <th>Data</th>
          <th>Pesquisa</th>
          <th>Escala</th>
          <th>Fila</th>
          <th>Ramal</th>
          <th>Número</th>
          <th>Situação</th>
          <th>Nota</th>
          {canDownloadRecording && <th>Gravação</th>}
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.id}>
            <td>{formatDate(item.createdAt)}</td>
            <td>{item.surveyName}</td>
            <td>{scaleLabel(item.scale)}</td>
            <td>{item.queueName || '—'}</td>
            <td>{item.agentExtension || '—'}</td>
            <td>{item.callerNumber || '—'}</td>
            <td>{statusLabel(item.status)}</td>
            <td>{scoreLabel(item.score)}</td>
            {canDownloadRecording && (
              <td>
                {item.recordingProtocol ? (
                  <button type="button" className="filter-button" onClick={() => onDownloadRecording(item.recordingProtocol)}>
                    Baixar
                  </button>
                ) : '—'}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
